/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Map_ToInputs */

const cs_pipelines_map_to = /** @type {(inputs: Pipelines_Map_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

const en_pipelines_map_to = /** @type {(inputs: Pipelines_Map_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Pipelines_Map_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_map_to = /** @type {((inputs?: Pipelines_Map_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Map_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_map_to(inputs)
	return cs_pipelines_map_to(inputs)
});